import { Col } from '@guestyci/foundation/esm/Layout';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';

const contentBreakpoints = {
  xs: 0,
  sm: 0,
  md: 4,
  lg: 4,
  xl: 4,
};

const useStyles = createStyles(() => ({
  marketingSideContainer: {
    background: '#3B96FF',
  },
  marketingIframe: {
    border: 'none',
    height: '100%',
  },
}));

const MarketingContainer = () => {
  const classes = useStyles();

  return (
    <Col
      breakpoints={contentBreakpoints}
      justify="center"
      id="marketing-container"
      className={classes.marketingSideContainer}
    >
      <iframe
        src="https://www.guesty.com/start-gfh-animation/"
        title="Guesty Marketing Material"
        id="marketing-container-iframe"
        className={classes.marketingIframe}
      />
    </Col>
  );
};

export default MarketingContainer;
